import Image from 'next/image';
import { ImageOnlyPTT } from '@adapters/prismic/types/plp';
import { useLocale } from '@hooks/useLocale';
import { addLocaleToUrl } from '@utils/url';

import styles from './PTTAsImage.module.scss';
import {
  PromotionEventName,
  trackPromotionEvent,
  InteractionLocation,
} from '@utils/gtm/ga4/trackPromotionEvents';
import { determinePageType, buildCreativeSlotName } from '@utils/gtm/ga4/utils';

interface PTTAsImageProps {
  ptt: ImageOnlyPTT;
  isPriority: boolean;
}

const PTTAsImage = ({ ptt, isPriority }: PTTAsImageProps) => {
  const locale = useLocale();
  const { backgroundImage, urlPath } = ptt?.product_tile || {};
  if (!backgroundImage?.url || !backgroundImage?.alt) {
    return null;
  }

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      trackPromotionEvent({
        eventName: PromotionEventName.selectPromotion,
        page: {
          path: window.location.pathname,
          page_type: determinePageType(),
        },
        interaction: {
          coop_brand: ptt.product_tile['co-op_brand_attribute'] || null,
          interaction_location: InteractionLocation.PTT,
        },
        ecommerce: {
          creative_name: `link,${urlPath}`,
          creative_slot: buildCreativeSlotName({
            sliceIndex: ptt?.position,
            interactionLocation: InteractionLocation.PTT,
            itemIndex: ptt?.treatment,
          }),
          promotion_id: backgroundImage.alt,
          promotion_name: backgroundImage.alt,
          isVideo: false,
        },
      });
    }
  };

  return (
    <div className={styles.hitImageContainer}>
      <a
        href={addLocaleToUrl(urlPath || '', locale)}
        className={styles.hitImageLink}
        onClick={handleClick}
      >
        <Image
          src={backgroundImage.url}
          alt={backgroundImage.alt}
          layout="responsive"
          width={backgroundImage.dimensions.width}
          height={backgroundImage.dimensions.height}
          priority={isPriority}
          sizes="(min-width: 1128px) 240px,(min-width: 1000px) 250px,(min-width: 767px) 324px,(min-width: 600px) 191px, (min-width: 327px) 50vw, 100vw"
        />
      </a>
    </div>
  );
};

export default PTTAsImage;
